export default __webpack_public_path__ + "static/media/aw.7f525d4f.svg";